import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMagnifyingGlassTiltedRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={141}
    height={141}
    fill="none"
    {...props}
  >
    <g transform="scale(-1 1)rotate(-45 89.492 127.96)">
      <rect
        width={33.104}
        height={53.794}
        fill="url(#Magnifying_glass_tilted_right_svg__a)"
        rx={5}
      />
      <rect
        width={33.104}
        height={53.794}
        fill="url(#Magnifying_glass_tilted_right_svg__b)"
        rx={5}
      />
      <rect
        width={33.104}
        height={53.794}
        fill="url(#Magnifying_glass_tilted_right_svg__c)"
        rx={5}
      />
      <rect
        width={33.104}
        height={53.794}
        fill="url(#Magnifying_glass_tilted_right_svg__d)"
        rx={5}
      />
    </g>
    <path
      fill="url(#Magnifying_glass_tilted_right_svg__e)"
      fillRule="evenodd"
      d="M84.132 104.855c-26.313 0-47.643-21.33-47.643-47.643C36.49 30.9 57.82 9.57 84.132 9.57c26.312 0 47.642 21.33 47.642 47.642s-21.33 47.643-47.642 47.643m0-7.711c-22.054 0-39.932-17.878-39.932-39.932 0-22.053 17.878-39.931 39.932-39.931 22.053 0 39.931 17.878 39.931 39.931 0 22.054-17.878 39.932-39.931 39.932"
      clipRule="evenodd"
    />
    <g fillRule="evenodd" clipRule="evenodd">
      <path
        fill="url(#Magnifying_glass_tilted_right_svg__f)"
        d="M84.131 103.778c-25.717 0-46.565-20.848-46.565-46.566 0-25.717 20.848-46.565 46.565-46.565s46.565 20.848 46.565 46.565c0 25.718-20.848 46.566-46.565 46.566m0-7.537c-21.555 0-39.028-17.474-39.028-39.029S62.576 18.184 84.13 18.184s39.029 17.473 39.029 39.028-17.474 39.029-39.029 39.029"
      />
      <path
        fill="url(#Magnifying_glass_tilted_right_svg__g)"
        d="M84.131 103.778c-25.717 0-46.565-20.848-46.565-46.566 0-25.717 20.848-46.565 46.565-46.565s46.565 20.848 46.565 46.565c0 25.718-20.848 46.566-46.565 46.566m0-7.537c-21.555 0-39.028-17.474-39.028-39.029S62.576 18.184 84.13 18.184s39.029 17.473 39.029 39.028-17.474 39.029-39.029 39.029"
      />
    </g>
    <circle
      cx={40.956}
      cy={40.956}
      r={40.956}
      fill="url(#Magnifying_glass_tilted_right_svg__h)"
      transform="matrix(-1 0 0 1 125.088 16.256)"
    />
    <g transform="matrix(-1 0 0 1 124.063 17.28)">
      <circle cx={39.932} cy={39.932} r={39.932} fill="#64D0EA" />
      <circle
        cx={39.932}
        cy={39.932}
        r={39.932}
        fill="url(#Magnifying_glass_tilted_right_svg__i)"
      />
    </g>
    <ellipse
      cx={102.767}
      cy={40.229}
      fill="url(#Magnifying_glass_tilted_right_svg__j)"
      rx={7.276}
      ry={8.96}
      transform="rotate(-38.896 102.767 40.23)"
    />
    <defs>
      <linearGradient
        id="Magnifying_glass_tilted_right_svg__a"
        x1={2.775}
        x2={21.858}
        y1={45.664}
        y2={8.081}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A0659C" />
        <stop offset={1} stopColor="#895792" />
      </linearGradient>
      <linearGradient
        id="Magnifying_glass_tilted_right_svg__b"
        x1={16.503}
        x2={16.552}
        y1={2.337}
        y2={21.226}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6C3B74" />
        <stop offset={1} stopColor="#845590" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Magnifying_glass_tilted_right_svg__c"
        x1={33.542}
        x2={10.856}
        y1={36.707}
        y2={36.025}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.115} stopColor="#703D7A" />
        <stop offset={1} stopColor="#703D7A" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Magnifying_glass_tilted_right_svg__e"
        x1={84.132}
        x2={84.132}
        y1={9.57}
        y2={104.855}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.379} stopColor="#344A7D" />
        <stop offset={0.633} stopColor="#785790" />
        <stop offset={0.837} stopColor="#785790" />
        <stop offset={1} stopColor="#9872A2" />
      </linearGradient>
      <linearGradient
        id="Magnifying_glass_tilted_right_svg__f"
        x1={84.131}
        x2={84.131}
        y1={10.647}
        y2={103.778}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#475890" />
        <stop offset={1} stopColor="#7A4D87" />
      </linearGradient>
      <linearGradient
        id="Magnifying_glass_tilted_right_svg__h"
        x1={40.956}
        x2={40.956}
        y1={0}
        y2={81.913}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#204083" />
        <stop offset={1} stopColor="#523573" />
      </linearGradient>
      <linearGradient
        id="Magnifying_glass_tilted_right_svg__j"
        x1={102.767}
        x2={102.767}
        y1={31.269}
        y2={49.189}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DCDBF2" />
        <stop offset={0.209} stopColor="#DCDBF2" stopOpacity={0.848} />
        <stop offset={1} stopColor="#DCDBF2" stopOpacity={0} />
      </linearGradient>
      <radialGradient
        id="Magnifying_glass_tilted_right_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(92.442 8.77 7.61)scale(10.2814 23.8945)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2F1A3D" />
        <stop offset={1} stopColor="#532D64" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="Magnifying_glass_tilted_right_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(.00004 -22.582 41.997 .00007 84.131 32.634)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.704} stopColor="#566298" />
        <stop offset={0.787} stopColor="#566298" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="Magnifying_glass_tilted_right_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(90 -1.136 41.068)scale(48.4688)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.651} stopColor="#33A2F3" stopOpacity={0} />
        <stop offset={1} stopColor="#33A2F3" />
      </radialGradient>
    </defs>
  </svg>
);
export default SvgMagnifyingGlassTiltedRight;
